<style scoped>
  .edit-button {
    left: 200% !important;
    margin-bottom: 250px;
  }
</style>

<template>
  <v-card>
    <v-card-text>
      <v-row align="center" justify="center">
        <v-avatar size="256" class="avatar-button">
          <v-icon size="256">mdi-account-circle</v-icon>
        </v-avatar>
      </v-row>
      <v-row justify="center" class="headline text--primary mt-4 mb-2">
        <v-icon class="pr-1" color="primary" v-if="isUserAdmin()" title="Users Admin">mdi-star</v-icon>
        <span>Welcome {{user.first_name}}</span>
      </v-row>
      <v-row justify="center">
        <p>{{user.title}}</p>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  methods: {
    isUserAdmin() {
      return this.user.roles.includes('users_administrator') || this.user.roles.includes('admin');
    },
  },
  computed: {
    user: vm => vm.$store.getters.user,
  },
};
</script>
